import { TextField } from '@calendly/form';
import { HtmlParser } from '@calendly/html-parser';
import { I18n } from '@calendly/i18n';
import { BodyText, TitleText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
const containerCss = "cq663rm";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const containerNewFormCss = "c1ck16sc";
const ContainerNewForm = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerNewFormCss, props.className)} />;
});
const crudContainerCss = "c1tv3ois";
const crudFieldCss = "cjwqwp9";
export const PaymentTerms = ({
  bold = false,
  newForm = false,
  variant = 'default'
}) => {
  if (variant === 'crud') {
    return <div className={crudContainerCss} data-testid="payment-terms-crud">
        <TitleText level={3} size="medium">
          {I18n.t('publisher.event_type_editor_crud.payments.additional_settings_title')}
        </TitleText>
        <div className={crudFieldCss}>
          <TextField aria-label={I18n.t('publisher.event_type_editor_crud.payments.payment_terms_label')} label={I18n.t('publisher.event_type_editor_crud.payments.payment_terms_label')} name="paymentTerms" type="textarea" proTip={HtmlParser(I18n.t('publisher.event_types.payment_method.payment_terms_tip'))} rows="3" maxLength="1024" />
        </div>
      </div>;
  }
  const ContainerComponent = newForm ? ContainerNewForm : Container;
  return <ContainerComponent>
      <BodyText weight={bold ? 'bold' : 'normal'}>{I18n.t('publisher.event_types.payment_method.payment_terms')}</BodyText>
      <TextField aria-label={I18n.t('publisher.event_types.payment_method.payment_terms')} name="paymentTerms" type="textarea" proTip={HtmlParser(I18n.t('publisher.event_types.payment_method.payment_terms_tip'))} rows="3" maxLength="1024" />
    </ContainerComponent>;
};

require("./payment_terms.wyw-in-js.css!=!../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./payment_terms.js");